export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: any;
};

export type AdvancedMetricSeries = {
  __typename?: 'AdvancedMetricSeries';
  name: Scalars['String'];
  values: Array<Scalars['Float']>;
};

export type AdvancedMetricSummary = {
  __typename?: 'AdvancedMetricSummary';
  allowProductSelection: Scalars['Boolean'];
  code: Scalars['String'];
  labels: Array<Scalars['String']>;
  series: Array<AdvancedMetricSeries>;
  title: Scalars['String'];
  type: AdvancedMetricType;
};

export type AdvancedMetricSummaryInput = {
  variantIds?: InputMaybe<Array<Scalars['ID']>>;
};

export enum AdvancedMetricType {
  Currency = 'currency',
  Number = 'number'
}

export type Mutation = {
  __typename?: 'Mutation';
  /** @deprecated Server side tracking is no longer supported */
  pageVisit?: Maybe<Scalars['Boolean']>;
};


export type MutationPageVisitArgs = {
  input?: InputMaybe<PageVisitInput>;
};

export type Query = {
  __typename?: 'Query';
  advancedMetricSummaries: Array<AdvancedMetricSummary>;
};


export type QueryAdvancedMetricSummariesArgs = {
  input?: InputMaybe<AdvancedMetricSummaryInput>;
};

export type PageVisitInput = {
  path?: InputMaybe<Scalars['String']>;
  productId?: InputMaybe<Scalars['ID']>;
  productVariantId?: InputMaybe<Scalars['ID']>;
};

export type AdvancedMetricSummariesQueryVariables = Exact<{
  input?: InputMaybe<AdvancedMetricSummaryInput>;
}>;


export type AdvancedMetricSummariesQuery = { __typename?: 'Query', advancedMetricSummaries: Array<{ __typename?: 'AdvancedMetricSummary', code: string, title: string, type: AdvancedMetricType, allowProductSelection: boolean, labels: Array<string>, series: Array<{ __typename?: 'AdvancedMetricSeries', name: string, values: Array<number> }> }> };
